"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _material = require("@mui/material");

var _react = _interopRequireDefault(require("react"));

var LimitInputCharacters = function LimitInputCharacters(_ref) {
  var value = _ref.value,
      limit = _ref.limit,
      boxProps = (0, _objectWithoutProperties2["default"])(_ref, ["value", "limit"]);
  var letterCount = value ? value.length : 0;
  return /*#__PURE__*/_react["default"].createElement(_material.Box, (0, _extends2["default"])({
    component: "span",
    width: 1,
    textAlign: "right",
    className: limit > letterCount ? 'Body-Small-Success' : 'Body-Small-Error'
  }, boxProps), "".concat(limit - letterCount, " characters left"));
};

var _default = LimitInputCharacters;
exports["default"] = _default;